import { StudentSurvey } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    count: 0,
    item: null,
    //
    itemsPerPage: 10,
    pageText: '',
    loading: false,
    //
    searchParams: {},
  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
        }
        const [count, items] = await Promise.all([
          StudentSurvey.count(searchParams),
          StudentSurvey.search(searchParams),
        ])

        if (count > (page - 1) * itemsPerPage || page === 1) {
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > count || pageStop === -1 ? count : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${count}`

          commit('changeState', {
            items,
            count,
            itemsPerPage,
            searchParams,
            pageText,
          })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (count > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async search({ commit, state, dispatch }, query) {
      const searchParams = {
        _limit: state.itemsPerPage,
        ...query,
        _sort: 'createdAt:DESC',
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', {})
    },
    fetchAll({ state }) {
      return StudentSurvey.fetch({ ...state.searchParams, _limit: -1, _sort: 'createdAt:DESC' })
    },
    update(_, {id, ...params}) {
      return StudentSurvey.update(id, params)
    }
  },
  mutations: {},
  getters: {
    getItems: state => state.items,
    getItem: state => state.item,
  },
}
